const attributes = {url: 'source_url', event_shown: 'event', event_identifier: 'iptc_event_id', person: 'person_in_image', artwork: 'ao_artwork', date_created: 'captured_at', byline: 'description_writer', special_instructions: 'instructions'};
const tagSubTypes = {keywords: 'keyword', product: 'product', person: 'person'};

export const standardAttribute = field => attributes[field.standard_field_key] || field.standard_field_key;

export function standardDisplayValue(field, asset, attrs = {}) {
    const subtype = tagSubTypes[field.standard_field_key];
    if (subtype) return (asset.tags || []).filter(tag => tag.sub_type === subtype).map(tag => tag.name);
    const attribute = standardAttribute(field);
    return attrs[attribute] ?? asset[attribute];
}

export function standardEditValue(field, value) {
    return field.multi ? String(value).split(/[,;\n]/).map(item => item.trim()).filter(Boolean) : value;
}
